export const headers = {
    initialHeaders: [
      { title: "Nombre del aspirante", field: "personName", child: null },
      { title: "Nivel de formación", field: "levelEducation", child: null },
      { title: "Residencia", field: "provinceName", child: null },
      {
        title: "Fecha postulación",
        field: 'postulationDate',
        child: null,
      },
      //{title: "Profesion", field: "chargeRequested", child: null,},
      {
        title: "Años de Experiencia",
        field: "yearsExperience",
        child: null,
      },
      {
        title: "Estado",
        field: "statusDescriptionPostulate",
        child: null,
      },
    ],
    otherHeaders: [
      { title: "Primer nombre", field: "firstName", child: null },
      { title: "Segundo nombre", field: "secondName", child: null },
      { title: "Primer apellido", field: "surname", child: null },
      { title: "Segundo apellido", field: "secondSurname", child: null },
      { title: "Tipo documento", field: "documentTypeName", child: null },
      { title: "Número documento", field: "documentNumber", child: null },
      { title: "Fecha de expedición", field: "documentIssueDate", child: null },
      { title: "Fecha de nacimiento", field: "dateBirth", child: null },
      { title: "Género", field: "domainGender", child: null },
      { title: "Número celular", field: "cellPhoneNumber", child: null },
      { title: "Teléfono", field: "phone", child: null },
      { title: "Correo electrónico", field: "externalEmail", child: null },
      { title: "Residencia", field: "nameTown", child: null },
      { title: "Estado civil", field: "maritalStatus", child: null },
      { title: "Talla camisa", field: "shirtSize", child: null },
      { title: "Talla pantalón", field: "pantSize", child: null },
      { title: "Talla de calzado", field: "shoeSize", child: null },
      { title: "Estudios complementarios", field: "complementaryStudies", child: null },
      { title: "Vehículo propio", field: "ownVehicle", child: null },
      { title: "Trabaja actualmente", field: "currentlyWorking", child: null },
      { title: "Número de hijos", field: "childrens", child: "name" },
      { title: "Años de experiencia", field: "yearsExperience", child: null },
      { title: "Profesión", field: "occupation", child: null },
    ],
  };
  
  export const defaultValues = {
    creationUser: "Developer",
  };

  export const experienceYears = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30,
  ];
  


  export const mockData = [
    {
      nombre :  'Carolina Castro',
      formacion:  'Profesional',
      profesion:  'Arquitecto',
      añosExperiencia: 9,
      residencia: 'Medellin',
      estado: 'En proceso'
    },
    {
      nombre :  'Santiago Pineda',
      formacion:  'Profesional',
      profesion:  'Panadero',
      añosExperiencia: 5,
      residencia: 'Barranquilla',
      estado: 'Potulado'
    },
    {
      nombre :  'Amparo Jimenez',
      formacion:  'Profesional',
      profesion:  'Enfermera',
      añosExperiencia: 2,
      residencia: 'Cali',
      estado: 'Postulado'
    }
  ]

  export const vacancieUser = [
    { 
      callType: "Mixta",
      contracType: null,
      creationDate: "15/07/2021 07:35:54",
      creationUser: "BACKEND",
      dateUpdate: null,
      id: "601dba3e-3ed6-477b-8cdd-052b9c01a013",
      observation: "",
      reason: null,
      requisition: {
        admissionDate: "05/01/2021 05:00:00",
        amount: null,
        chargeApplicant: {
          approvers: "770ad1c2-559e-4188-92cb-8b96018ed898,4c232b4a-ceaf-4a73-833a-7dac60337452",
          creationDate: "2021-06-23T15:20:39.256",
          creationUser: "DEVELOPER",
          dateUpdate: "2021-07-15T15:38:00.961",
          denomination: "Cargo",
          id: "e1bfcd5d-c51f-4a94-bd31-61a745eda067",
          status: "Activo",
          userEdit: "DEVELOPER",
        },
        chargeRequested: {
          approvers: "67cf2c37-0c0f-4d67-afa0-2faa24c94ba2",
          creationDate: "2021-05-26T16:11:03.177",
          creationUser: "DEVELOPER",
          dateUpdate: null,
          denomination: "Cargo",
          id: "770ad1c2-559e-4188-92cb-8b96018ed898",
          status: "Activo",
          userEdit: "",
        },
        code: "REQ",
        contractType: "Obra_labor",
        creationDate: "15/07/2021 07:35:34",
        creationUser: "jangulorama2@gmail.com",
        id: "84f8e901-438c-4d06-8c07-62f772ffb055",
        observations: "Rterterterte",
        process: {
          code: "GH",
          description: "Gestión Humana",
          id: "f77e6ac2-5cc7-11eb-ae93-0242ac130002",
          status: "ACTIVO",
        },
        regional: {
          code: "Bogotaso",
          creationDate: "09/04/2021 21:07:30",
          creationUser: "Developer",
          dateUpdate: "",
          id: "64974669-3569-453b-b54f-ca22f86875d6",
          name: "Bogotaso",
          status: "Activo",
          userEdit: "",
        },
        replaceUser: null,
        requestDate: "15/07/2021 07:35:34",
        requestReason: "Nuevo Cargo",
        requestUser: "Nombre Del Jefe Solicitante",
        requisition: "REQ-300",
        requisitionNumber: 300,
        retirementDate: null,
        retirementReason: null,
        status: "Publicado",
        salary: 365800,
        salaryAgreed: false,
        status: "Activa",
        userEdit: null,
      }
    }
] 

  export const vacancieUsers = 
    { 
      attachment: {
        cv: "JVBERi0xLjQKJdPr6eEKMSAwIG9iago8PC9UaXRsZSA8RkVGRj…JbmZvIDEgMCBSPj4Kc3RhcnR4cmVmCjExMDQ5MjgKJSVFT0Y=", 
        photo: "JVBERi0xLjQKJSDi48/TCjQKMApvYmoKPDwKL1R5cGUKL0NhdG…uZm8KNQowClIKPj4Kc3RhcnR4cmVmCjk5NDMyCiUlRU9GCg=="
      },
      complementaryStudies: "ing de tales,",
      currentlyWorking: "Sí",
      documentIssueDate: 'Wed May 05 2021 00:00:00 GMT-0500',
      levelEducation: "Profesional",
      listChildren: [{
        birthDate: 'Thu Sep 02 1993 13:20:20 GMT-0500',
        name: "antonio perano" ,       
      }],
      maritalStatus: "Soltero(a)",
      numberChildren: 1,
      ownVehicle: "No",
      pantSize: "34",
      person: {
        cellPhoneNumber: "0123456789",
        creationUser: "DEV",
        dateBirth: "",
        documentNumber: "12121223",
        documentType: "CC",
        externalEmail: "jangulorama1@gmail.com",
        firstName: "Juancho",
        gender: "MASCULINO",
        password: "",
        phone: "0000234424",
        secondName: null,
        secondSurname: "Lopez",
        surname: "Uribe",
      },
      profession: "ad69ccf3-a363-4459-9529-0574b118e319",
      province: "0f6cf8f7-5337-4b97-bf58-87c99a98b4a5",
      shirtSize: "S",
      shoeSize: "39",
      town: "0f6cf8f7-5337-4b97-bf58-87c99a98b9b7",
      userCreation: "DEV",
      yearsExperience: 6,
    }
  

  export const titlesVacancie = {
    firstGrid :[
      { title: 'Fecha de nacimiento', field : 'dateBirth', child: null},
      { title : 'Sexo', field : 'person', child: 'gender'},
      { title : 'Telefono', field : 'person', child: 'phone'} ,
      { title : 'Correo Electrónico', field : 'person', child: 'externalEmail'},
      { title : 'Estado civil', field : 'maritalStatus', child: null },
      { title : 'Nivel de formación', field : 'levelEducation', child: null},
      { title :  'Profesión', field : 'profession', child: null},
      { title : 'Fecha en la que se postulo', field : 'documentIssueDate', child: null},
    ],
    secondGrid: [
      { title : 'Años de experiencia', field : 'yearsExperience', child: null},
      { title : 'Ciudad', field : 'town', child: null},
      { title : 'Talla camisa', field : 'shirtSize', child: null},
      { title : 'Talla pantalon', field : 'pant', child: null},
      {title : 'Talla calzado', field : 'shoeSize', child: null},
      {title : 'Vehiculo propio', field : 'ownVehicle', child: null},
      {title : 'Trabaja actualmente', field : 'currentlyWorking', child: null},
      {title : 'Numero de hijos', field : 'numberChildren', child: null},
    ]
  }